export default {
	data() {
		return {
			fields: {},
			valid: false,
			loading: false,
			errors: [],
			field_errors: {},
			preventChange: false,
		}
	},
	watch: {
		fields: {
			deep: true,
			handler(fields) {
				if (!this.preventChange) {
					this.$emit('change', fields)
				}
			},
		},
	},
	methods: {
		setField(field, val) {
			this.$set(this.fields, field, val)
		},
		getField(field) {
			return this.fields[field]
		},
		getAllErrors() {
			const errors = []
			this.$refs.form.inputs.forEach((e) => {
				if (e.errorBucket && e.errorBucket.length) {
					errors.push(...e.errorBucket)
				}
			})
			return errors
		},
		async beforeSubmit() {
			//Hook can be overwritten in child
		},
		validationFailed() {
			//Hook can be overwritten in child
		},
		validate(e) {
			return new Promise((resolve) => {
				this.beforeSubmit().then(() => {
					if (!this.$refs.form.validate()) {
						if (e) {
							e.preventDefault()
							e.stopImmediatePropagation()
						}
						this.validationFailed()
						resolve(false)
					} else {
						this.valid = true
						resolve(true)
					}
				})
			})
		},
		reset() {
			this.fields = this.$options.data.apply(this).fields
			this.errors = []
			this.field_errors = {}
			this.resetForm()
		},
		resetForm() {
			//Hook can be overwritten in child
		},
		submit() {
			if (!this.valid) return

			this.loading = true

			return this.submitForm()
				.then((ok) => {
					this.loading = false
					const isSuccess = ok !== false

					if (!isSuccess) return

					this.$emit('success', ok, this)
					this.preventChange = true

					if (this.$refs.form) {
						this.$refs.form.reset()
						setTimeout(() => {
							this.reset()
							this.$nextTick(() => {
								this.preventChange = false
							})
						}, 1)
					}
				})
				.catch((err) => {
					this.loading = false
					this.$emit('error', err, this)
				})
		},
		async validateAndSubmit() {
			if (await this.validate()) {
				await this.submit()
			}
		},
	},
}
